<template>
    <div class="card card-danger card-outline">
        <div class="card-body ">
            <div class="form-group">
                <div>
                    <label>{{$t('general.series')}}</label>
                </div>
                <div class="row">
                    
                    <table class="table table-sm table-striped">
                        <thead>
                            <tr >
                                <th>
                                    <select class="custom-select form-control-sm" v-model="serieSeleccionada">
                                        <option value="0">{{$t('general.seleccioneserie')}}</option>
                                        <optgroup label="VeriFactu" v-if="seriesVerifactu.length > 0">
                                            <option v-for="serie in seriesVerifactu" :key="serie.id" :value="serie.id">
                                                {{ serie.nombre_serie }}
                                            </option>
                                        </optgroup>
                                        <optgroup label="TicketBai" v-if="seriesTicketBai.length > 0">
                                            <option v-for="serie in seriesTicketBai" :key="serie.id" :value="serie.id">
                                                {{ serie.nombre_serie }}
                                            </option>
                                        </optgroup>
                                        <optgroup label="Otras Series" v-if="seriesRestantes.length > 0">
                                            <option v-for="serie in seriesRestantes" :key="serie.id" :value="serie.id">
                                                {{ serie.nombre_serie }}
                                            </option>
                                        </optgroup>
                                    </select>
                                </th>
                                <th>
                                    <button class="btn btn-primary" @click="agregarSerie()">Añadir</button>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="serie in seriesCompania" :key="serie.id_serie">
                                <td>{{ serie.nombre_serie }}</td>
                                <td><span v-if="serie.verifactu_serie==1" class="badge badge-primary">VeriFactu</span><span v-if="serie.ticketbai_serie==1" class="badge badge-primary">TicketBai</span></td>
                                <td><button class="btn btn-sm btn-danger" title="Eliminar" @click="eliminarSerie(serie.id_serie)"><i class="fas fa-times"></i></button></td>
                            </tr>
                        </tbody>
                    </table>
                    
                </div>
            </div>
        </div>        
    </div>
</template>

<script>
import { PwgsApi } from '../../../../../services/PwgsApi';
export default {
    props: {
        datos: {
            type: Object
        },
        
    },
    mounted(){
        this.obtenerSeries();
        this.obtenerSeriesCompania();
    },
    data() {
        return {
            serieSeleccionada: 0,
            series:[],
            seriesCompania:[],
        }
    },
    computed: {
        seriesVerifactu() {
            return this.series.filter(s => s.verifactu_serie == 1);
        },
        seriesTicketBai() {
            return this.series.filter(s => s.ticketbai_serie == 1);
        },
        seriesRestantes() {
            return this.series.filter(s => s.verifactu_serie == 0 && s.ticketbai_serie == 0);
        }
    },
    methods: {
        async obtenerSeries(){
            const api = new PwgsApi();
            const resp = await api.get('/lineas-facturacion/todas');
            this.series = resp.datos;
        },
        async obtenerSeriesCompania(){
            const api = new PwgsApi();
            const resp = await api.get('companias/'+this.datos.idcompañia+'/lineas-facturacion');
            this.seriesCompania = resp.datos;
        },
        async eliminarSerie(id){
            const api = new PwgsApi();
            await api.delete('companias/'+this.datos.idcompañia+'/lineas-facturacion/'+id);
            this.obtenerSeriesCompania();
        },
        async agregarSerie(){
            if(this.serieSeleccionada==0){
                alert('selecciona  una serie');
            }else{
                const api = new PwgsApi();
                const body = {"id_linea":this.serieSeleccionada};
                await api.post('companias/'+this.datos.idcompañia+'/lineas-facturacion', body);
                this.obtenerSeriesCompania();
            }
        }
    },
    watch: {
        datos(){
            this.obtenerSeries();
            this.obtenerSeriesCompania();
        }
    }
}
</script>